


























import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      showDialog: false,
      titlePageChild: "Assign Request",
      subtitlePageChild: "List of all request created",
    };
  },
  methods: {
    handlerShowDialog() {
      this.showDialog = true
    }
  }
});
